import { useEffect, useState } from 'react';

interface IReturn {
    timer: number;
}

export const useTimer = (duration: number | undefined): IReturn => {
    const [timer, setTimer] = useState<number>(0);

    useEffect(() => {
        let interval: NodeJS.Timer | null = null;

        if (duration) {
            setTimer(duration);
            interval = setInterval(() => {
                setTimer((prevVal) => {
                    const result = prevVal - 1;
                    if (result <= 0) {
                        clearInterval(interval as NodeJS.Timer);
                    }
                    return result;
                });
            }, 1000);
        }

        return (): void => {
            if (interval) {
                clearInterval(interval);
            }
        };
    }, [duration]);

    return { timer };
};
